module.exports = __webpack_public_path__ + "static/img/fifth2.600d7a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/fifth2.png
// module id = 1SQ0
// module chunks = 25